import React from 'react';
import { isEmpty } from 'lodash';
import CardDetailViewTabBar from './CardDetailViewTabBar';
import './CardDetailViewHeader.scss';
import cx from 'classnames';

class CardDetailViewHeader extends React.Component {
  render() {
    const {
      meta,
      data,
      aclQueryMode,
      detailHeaderContent,
      tabs,
      selectedTabIndex,
      onTabClicked,
      noHeaderPadding,
    } = this.props;

    const detailHeaderContentInstance = detailHeaderContent
      ? React.cloneElement(detailHeaderContent, {
          meta,
          data,
          hideActions: this.props.hideActions,
          aclQueryMode,
        })
      : detailHeaderContent;

    return (
      <header
        className={cx('card-detail-view-header', {
          'no-padding': noHeaderPadding,
        })}
      >
        {detailHeaderContentInstance}
        {!isEmpty(tabs) && tabs.length > 1 ? (
          <CardDetailViewTabBar
            tabs={tabs}
            noHeaderPadding={noHeaderPadding}
            selectedTabIndex={selectedTabIndex}
            onTabClicked={onTabClicked}
          />
        ) : (
          <span>&nbsp;</span>
        )}
      </header>
    );
  }
}

export default CardDetailViewHeader;
